import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import UnitPlanCard from "../UnitPlan/UnitPlanCard";
import CustomizedTabs from "../CustomizedTabs";
import UnitPlanModal from "../UnitPlan/UnitPlanModal";
// import TierPlanModal from "./TierPlanModal";

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    flexWrap: "wrap",
  },
  annualPlanCard: {
    marginBottom: "30px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "10px",
    }
  },
  noDataAvailable: {
    margin: '20px',
  }
}));

function PlanDetailsPage(props) {
  const { parentState, modalState, setModalState, userRoles, getPlanDetails } = props;
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        direction="row"
        className={classes.cardWrapper}
        spacing={4}
      >
        <CustomizedTabs tabList={[`Unit Plans (${parentState?.unitPlans?.length || 0})`]} />
        {parentState?.unitPlans?.length ? (
          parentState?.unitPlans?.map((plan, index) => (
            <Grid
              item
              className={classes.annualPlanCard}
              key={index}
              md="6"
              xs="12"
            >
              <UnitPlanCard data={plan} {...props}/>
            </Grid>
          ))
        ) : (
          <div className={classes.noDataAvailable}>No Data available</div>
        )}
      </Grid>
      {modalState.isOpen && (
        <UnitPlanModal
          userRoles={userRoles}
          modalState={modalState}
          setModalState={setModalState}
          topics={parentState?.topics || []}
          getPlanList={getPlanDetails}
        />
      )}
    </>
  );
}

export default PlanDetailsPage;
